<template>
	<div class="table-responsive">
		<table class="table table-row-bordered">
			<thead>
				<tr class="fw-bold fs-6">
					<th>Nome do computador</th>
					<th>Memória RAM</th>
					<th>Tipo da CPU</th>
					<th>CPU cores</th>
					<th>CPU sockets</th>
					<th>Hostname</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>{{ props.system_info.computer_name }}</td>
					<td>{{ ram_memory }}</td>
					<td>{{ props.system_info.cpu_type }}</td>
					<td>{{ props.system_info.cpu_physical_cores }}</td>
					<td>{{ props.system_info.cpu_sockets }}</td>
					<td>{{ props.system_info.hostname }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script setup lang="ts">
	import { computed } from 'vue';

	const props = defineProps({
		system_info: { type: Object, required: true },
	});

	const ram_memory = computed(() => {
		const memory = props.system_info?.physical_memory;
		return memory && memory !== '-1'
			? Math.ceil(parseInt(memory) / (1024 * 1024 * 1024)) + 'GB'
			: '';
	});
</script>
